import { createApi, fetchBaseQuery, FetchBaseQueryError } from '@reduxjs/toolkit/query/react'
import { apiPath, baseUrl } from 'config'

import { setUser } from 'store/reducers-common'
import { disconnect } from 'store/reducers-common/Auth/slice'
import { getSignature } from 'utils/getSignature'
import { isUnauthorizedQueryError } from 'utils/isUnauthorizedQueryError'

import type { User } from 'types'

export const queryProfile = createApi({
  baseQuery: fetchBaseQuery({ baseUrl }),
  endpoints: (builder) => ({
    getProfile: builder.query<User, { skipSetStore?: boolean }>({
      providesTags: ['Profile'],
      queryFn: async (_arg, api, _extraOptions, baseQuery) => {
        const { deadline, signature } = await getSignature({
          primaryType: 'GetProfile',
          url: apiPath.getProfile,
        })

        if (!signature) {
          api.dispatch(disconnect())
          return { error: new Error('No signature') as unknown as FetchBaseQueryError }
        }

        const result = await baseQuery({
          headers: { deadline: `${deadline}`, signature },
          url: apiPath.getProfile,
        })

        if (result.error) {
          if (isUnauthorizedQueryError(result.error)) {
            api.dispatch(disconnect())
          }
          return { error: result.error as FetchBaseQueryError }
        }

        if (!result.data) {
          api.dispatch(disconnect())
          return { error: new Error('No profile data') as unknown as FetchBaseQueryError }
        }
        if (!_arg?.skipSetStore) {
          api.dispatch(setUser(result.data as User))
        }
        return { data: result.data as User }
      },
    }),
  }),
  reducerPath: 'profile',
  tagTypes: ['Profile'],
})

export const { useGetProfileQuery, useLazyGetProfileQuery } = queryProfile
